import { render, staticRenderFns } from "./xinwen.vue?vue&type=template&id=3bdafed5&scoped=true"
import script from "./xinwen.vue?vue&type=script&lang=js"
export * from "./xinwen.vue?vue&type=script&lang=js"
import style0 from "./xinwen.vue?vue&type=style&index=0&id=3bdafed5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bdafed5",
  null
  
)

export default component.exports